import {EnumLanguage} from "../EnumLanguage";

export const UXToast = {
    login: {
        requires: {
            [EnumLanguage.ru]: 'Введите эл. почту и пароль, чтобы войти',
            [EnumLanguage.en]: 'Enter email and password to login'
        },
        verified: {
            [EnumLanguage.ru]: 'Чтобы войти в систему нужно подтведить аккаунт в высланом Вам электронном письме',
            [EnumLanguage.en]: 'To login, you need to confirm your account in the e-mail sent to you'
        },
        error: {
            [EnumLanguage.ru]: 'Ошибка при попытке войти',
            [EnumLanguage.en]: 'Error when trying to login'
        }
    },
    registration: {
        requires: {
            [EnumLanguage.ru]: 'Введите эл. почту, пароль и повторите пароль, чтобы продолжить регистрацию',
            [EnumLanguage.en]: 'Enter email, password and repeat password to continue registration'
        },
        passwordsNotMatch: {
            [EnumLanguage.ru]: 'Пароли не совпадают',
            [EnumLanguage.en]: 'Passwords do not match'
        },
        passwordsTooShort: {
            [EnumLanguage.ru]: 'Пароль слишком короткий, минимум 6 символов',
            [EnumLanguage.en]: 'Password is too short, minimum 6 characters'
        }
    }
}